/**
 * Scrolling that reads the user's motion preference.
 *
 * `scroll-behavior: smooth` in global.css is gated on
 * `prefers-reduced-motion`, but CSS cannot override an explicit
 * `behavior: 'smooth'` passed to scrollIntoView or scrollTo: the argument
 * wins. Six call sites in Header and Footer passed it unconditionally, so a
 * user who had asked for no motion got smooth scrolling anyway on every nav
 * click. These two helpers are the only place `smooth` is named.
 */

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function behavior(): ScrollBehavior {
  return prefersReducedMotion() ? 'auto' : 'smooth';
}

/** Scroll an in-page anchor into view. No-op if the id is not on this page. */
export function scrollToId(id: string): void {
  document.getElementById(id)?.scrollIntoView({ behavior: behavior() });
}

/** Back to the top of the document. */
export function scrollToTop(): void {
  window.scrollTo({ top: 0, behavior: behavior() });
}
